import React, {Component} from 'react';
import {    makeRequest    }  from 'actions';
import {connect} from 'react-redux';

import {bindActionCreators} from 'redux';
import {FormControl, FormGroup, Row, Col, ControlLabel} from 'react-bootstrap';

class AmazonSearchPage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            filterOptions: {'term': ''},
             amazonProductsStatus: 'initial',
            amazonProducts:[],
        };
    };

    render() {
        var self = this;

        function onTermChange(event) {
            var updateOptions = {...self.state.filterOptions, term: event.target.value};
            self.setState({'filterOptions': updateOptions});
        }

        function searchProducts() {
            var queryParams = {};
            self.setState({'amazonProductsStatus': 'pending'});
            if (self.state.filterOptions.term !== '') {
                queryParams.term = self.state.filterOptions.term;
            }
            var methodData = {
                 "endpoint": "/get-amazon-products",
                'not_display_success_message': true,
             };
            self.props.makeRequest(queryParams, methodData).then(response => {
                self.setState({'amazonProducts': response.data.data, 'amazonProductsStatus':'fetched'});
            }).catch(error => {
                    console.log('Error', error.message);
                })
        }

        let productList;
        if (this.state.amazonProductsStatus == 'initial') {
            productList = null;
        } else if (this.state.amazonProductsStatus == 'pending') {
            productList = <div className="messageBox">Searching...</div>
        }  else if (_.size(this.state.amazonProducts) == 0) {
                productList = <div className="messageBox">No products found</div>
            } else {


            productList = self.state.amazonProducts.map((product, key) => (
                        <Row className="top15 ptop15">
                        <Col key={key} xs={6} md={6} className={product.img == 'image_not_found' ? 'amazon-product-item --not-available' : 'amazon-product-item'} >

                            <div className="amazon-product-item__image" >

                                <a href={product.OriginalUrl} target="_blank">
                                    {product.img == "image_not_found" ? <span>Click here to view the product on Amazon</span> :
                                    <img
                                        src={product.img}/>
                                    }

                                </a>

                            </div>
                        </Col>
                        <Col   xs={6} md={6}>
                        <div className="amazon-product-item__data-wrapper">
                                <div className="amazon-product-item__title">
                                    {product.name}
                                </div>
                                { !_.isUndefined(product.oldPrice) &&
                                <div className="amazon-product-item__old-price">
                                    {product.oldPrice}
                                </div>
                                }
                                <div className="amazon-product-item__price">
                                    {product.price == 'price_not_found' ?  'Price not found. Please, check it on the original product page': product.price}
                                </div>
                            </div>
                        </Col>
                        </Row>
                    ))
                    }

            return (

                <div>
                    <Row className="top15 ptop15">
                        <Col xs={3}>
                            <FormGroup>
                                <FormControl type="text" defaultValue="" onChange={onTermChange}
                                             placeholder="Term"/>
                            </FormGroup>
                        </Col>
                        <Col xs={3}>
                            <button className="btn btn-primary" onClick={(event) => searchProducts()} type="button">
                                Search
                            </button>
                        </Col>
                    </Row>
                    {productList}


                </div>
            );
        }
    }
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest}, dispatch);
}
function mapStateToProps(state, props) {
    return {

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AmazonSearchPage);